export default "__VITE_ASSET__bf2b3af4__"